(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DoublonProfile', DoublonProfile);

    DoublonProfile.$inject = ['$resource'];

    function DoublonProfile ($resource) {
        var service = $resource('api/doublon/profile', {}, {
            'query': {method: 'GET', isArray: true},
            'getByNomPrenom': {
                method: 'GET',
                url: 'api/doublon/profile/nomprenom/:userId/:nom/:prenom',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },

            'create':{
                method:'POST',
                url: 'api/doublon/profile',
            },
            'merge':{
                method:'PUT',
                url: 'api/doublon/profile',
            },
            'deleteByNomPrenom':{
                method:'DELETE',
                url: 'api/doublon/profile/nomprenom/:userId/:nom/:prenom',
            },
            'myPendingContributions':{
                method: 'GET',
                url: 'api/doublon/profile/mypendingcontributions',
                isArray: true
            },
            'myPendingHomonyms':{
                method: 'GET',
                url: 'api/doublon/profile/mypendinghomonyms',
                isArray: true
            },

            /* Validation User */
            'deletePendingContribution':{
                method:'DELETE',
                url: 'api/doublon/profile/id/:id',
            },
            'createProfileFromPendingContribution':{
                method:'POST',
                url: 'api/doublon/profile/id/:id/grade/:grade',
            },
            'deletePendingHomonym':{
                method:'DELETE',
                url: 'api/doublon/profile/id/:id',
            },
            'createProfileFromPendingHomonym':{
                method:'POST',
                url: 'api/doublon/homonyme/profile/id/:id/grade/:grade',
            },
            'connectProfileFromPendingHomonym':{
                method:'POST',
                url: 'api/doublon/profile/connect/id/:id/grade/:grade',
            }
        });

        return service;
    }



})();
